<template>
  <div class="m-holder-info table-shadow">
    <div class="select-box flex-between">
      <h2>{{holderInfo.symbol}}代币持有者</h2>
      <div class="flex-right">
        <i class="iconfont iconshaixuan"></i>
        <label>范围</label>
        <el-select
          v-model="num"
          placeholder="请选择"
          size="mini"
          class="holder-range"
          @change="selectRange"
        >
          <el-option label="最佳 10" :value="10"></el-option>
          <el-option label="最佳 20" :value="20"></el-option>
          <el-option label="最佳 30" :value="30"></el-option>
        </el-select>
      </div>
    </div>
    <div class="chart-container">
      <div class="head">
        <div class="flex-left">
          <i class="iconfont iconyonghu"></i>
          最佳{{num}}持有人总拥有{{(holdTotal*100/holderInfo.total).toFixed(2)}} %（{{holdTotal/100000000}} 代币）的BTY
        </div>
        <div class="total">
          <i class="iconfont iconjiangzhang"></i>
          <div class="total-text">
            <p>代币总供应量：{{holderInfo.total/100000000}} 代币</p>
            <p>总共代币持有人：{{holderInfo.holders}}</p>
          </div>
        </div>
      </div>
      <div class="chart-box">
        <div class="hold-chart" id="myChart"></div>
        <p>{{holderInfo.symbol}}</p>
      </div>
      <div
        class="tip"
      >注：最佳{{num}}账户所持有的总共 {{holdTotal/100000000}} 代币是来自 {{holderInfo.total/100000000}} 代币的总供应量</div>
    </div>
  </div>
</template>

<script>
import HolderInfoBase from "@/mixins/Holder/holderInfo.js";
export default {
  mixins: [HolderInfoBase]
};
</script>

<style lang="scss" scoped>
.m-holder-info {
  position: relative;
  .tip {
    padding: 0 20px;
    position: absolute;
    top: 430px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: $font_grey;
  }
  .select-box {
    h2 {
      font-size: 14px;
      color: $black;
      font-family: PingFangSC-Semibold;
    }
    .iconshaixuan {
      color: $grey_deep;
    }
    label {
      color: $black;
      width: 44px;
      text-align: center;
    }
    .holder-range {
      width: 100px;
    }
  }
  .chart-container {
    margin-top: 10px;
    // padding: 13px;
    background: $white;
    border: 1px solid rgba(235, 239, 241, 1);
    .head {
      padding: 13px;
      border-bottom: 1px solid #eeeeee;
      .flex-left {
        color: $black;
        font-size: 12px;
        i {
          margin-right: 10px;
          color: $grey_deep;
          font-size: 20px;
        }
      }
      .total {
        margin-top: 8px;
        color: $black;
        font-size: 12px;
        i {
          margin-right: 10px;
          color: $grey_deep;
          font-size: 20px;
          display: inline-block;
          vertical-align: top;
        }
        .total-text {
          display: inline-block;
          vertical-align: top;
        }
      }
    }
    .chart-box {
      position: relative;
      p {
        width: 100%;
        position: absolute;
        top: 120px;
        color: $black;
        text-align: center;
        font-size: 19px;
        font-weight: 600;
      }
    }
    .hold-chart {
      height: 625px;
    }
  }
}
</style>